export function parseMessageNowShip(messageAPI) {
  const {
    id,
    send_time: sendTime,
    message,
    sender: {
      id: senderId, user_role: userRole, image, name,
    },
    client_message_id: clientMessageId,
    is_deleted: isDeleted,
    is_edit: isEdited,
  } = messageAPI;
  return {
    id,
    sendTime,
    message,
    isDeleted: !!isDeleted,
    isEdited: !!isEdited,
    sender: {
      id: senderId,
      userRole,
      image,
      name,
    },
    clientMessageId,
  };
}

export function parseMessageListNowShip(messages) {
  return messages.map(parseMessageNowShip);
}

export function parseUserSeenStatusNowShip(userSeenStatus) {
  const {
    last_message_id: lastMessageId,
    user_role: userRole,
  } = userSeenStatus;
  return {
    userRole,
    lastMessageId,
  };
}

export function parseUserSeenStatusListNowShip(userSeenStatusList) {
  return userSeenStatusList
    .map(parseUserSeenStatusNowShip)
    .reduce((result, item) => ({
      ...result,
      [item.userRole]: item,
    }), {});
}



// WEBPACK FOOTER //
// ./foody/src/pages/ChatBox/parser.js